import { EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'
import { IhmIdentityBrokerServiceClient } from '@api/IhmIdentityBrokerServiceClient'
import { StoreIdServiceFor3P } from '@pages/StoreIdSelectionFor3P/utils/StoreIdServiceFor3P'
import { IhmIdentityBrokerTokenProvider } from '@api/utils/IhmIdentityBrokerTokenProvider'
import { LogoutUtils } from '@pages/LogoutPage/utils/LogoutUtils'
import { IIBServiceClient } from '@api/IIBServiceClient'

/**
 * This listener can be called for logging out
 */
export async function logout () {
    console.info('ATBase: logoutListener called.')

    if (EnvironmentDetail.isIhmIdentityBrokerAuthN()) {
        console.log('ATBase: IIB flow detected, redirecting to IIB login page.')
        // Clearing store details
        StoreIdServiceFor3P.resetStoreIdServiceFor3P()
        IhmIdentityBrokerTokenProvider.clear()
        if (EnvironmentDetail.isAndroid()) {
            console.debug('Clearing all the cookies from the Webview of the device')
            await LogoutUtils.clearAllCookiesFromWebView()
        }
        window.location.replace(IhmIdentityBrokerServiceClient.getIhmIdentityBrokerLoginUri())
        return
    } else if (EnvironmentDetail.isIIBAuthN()) {
        IIBServiceClient.logout()
    } else {
        window.top.location.hash = '/logout'
    }
}
